/* eslint-disable no-unused-vars */
import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router'
import imgError from '@/assets/images/error.png'
import { clearLastAppRoute, getLastAppRoute } from '@/utils/routeSession'
import { consultarCep } from '@/utils/consultaCep'

Vue.use(Vuex)

const store = {
   state: {
      // urlRest: 'https://escalador.oneway.tec.br/erp-jair-nilson/api/v1/',
      // urlRest: 'http://localhost:8080/erp-jair-nilson/api/v1/',
      // urlRest: 'https://unmanifest-unsecretarial-erline.ngrok-free.dev/erp-jair-nilson/api/v1/',
      // urlRest: 'https://zero-elected-was-silver.trycloudflare.com/erp-jair-nilson/api/v1/',
      urlRest: 'https://selections-font-discussions-shift.trycloudflare.com/erp-jair-nilson/api/v1/',
      loadingCount: 0,
      isLogado: false,
      dadosUsuario: null,
      tokenSessao: null,
      totalUnreadChatMessages: 0,
      dadosEmpresa: localStorage.getItem('empresaSelecionada') ? JSON.parse(localStorage.getItem('empresaSelecionada')) : null,
      empresa: localStorage.getItem('empresaSelecionada') ? JSON.parse(localStorage.getItem('empresaSelecionada')) : null,
      tabs: [],
      fontSizeDataLabels: localStorage.getItem('fontSizeDataLabels') ? parseInt(localStorage.getItem('fontSizeDataLabels')) : 14,
      secoes: {
         'pagina-inicial': {
            nome: 'Página Inicial',
            icon: 'fal fa-home',
            tabs: [
               { nome: 'Página Inicial', path: '/paginaInicial', icon: 'bx bx-home-circle', ativa: true }
            ]
         },
         'conversas': {
            nome: 'Conversas',
            icon: 'fal fa-comments',
            tabs: [
               { nome: 'Conversas', path: '/conversas', icon: 'bx bx-message-dots', ativa: true }
            ]
         },
         'tutoriais': {
            nome: 'Tutoriais',
            icon: 'fal fa-play-circle',
            tabs: [
               { nome: 'Tutoriais', path: '/tutoriais', icon: 'bx bx-play-circle', ativa: true }
            ]
         },
         'perfil': {
            nome: 'Perfil',
            icon: 'fal fa-user',
            tabs: [
               { nome: 'Perfil', path: '/perfil', icon: 'bx bx-user', ativa: true }
            ]
         },
         'usuarios': {
            nome: 'Usuarios',
            icon: 'fal fa-user',
            tabs: [
               { nome: 'Usuarios', path: '/usuarios', icon: 'bx bx-id-card', ativa: true }
            ]
         },
         'pdv-cadastros': {
            nome: 'Comercial',
            icon: 'fal fa-cash-register',
            tabs: [
               { nome: 'Pontos de Venda', path: '/cadastros/comercial/pontos-venda', icon: 'bx bx-store', ativa: true },
               { nome: 'Turnos', path: '/cadastros/comercial/turnos', icon: 'bx bx-time-five', ativa: false },
               { nome: 'Feriados', path: '/cadastros/comercial/feriados', icon: 'bx bx-calendar-star', ativa: false },
               { nome: 'Promoções', path: '/cadastros/comercial/promocoes', icon: 'bx bx-purchase-tag', ativa: false }
            ]
         },
         'empresas': {
            nome: 'Empresas',
            icon: 'fal fa-building',
            tabs: [
               { nome: 'Empresas', path: '/empresas', icon: 'bx bx-building', ativa: true }
            ]
         },
         'pessoas': {
            nome: 'Pessoas',
            icon: 'fal fa-id-card',
            tabs: [
               { nome: 'Clientes', path: '/Clientes', icon: 'bx bx-id-card', ativa: true },
               { nome: 'Fornecedores', path: '/Fornecedores', icon: 'bx bx-package', ativa: false },
               { nome: 'Vendedores', path: '/Vendedores', icon: 'bx bx-user', ativa: false },
               { nome: 'Técnicos', path: '/Tecnicos', icon: 'bx bx-wrench', ativa: false },
               { nome: 'Colaboradores', path: '/Colaboradores', icon: 'bx bx-user-circle', ativa: false },
               { nome: 'Transportadores', path: '/Transportadores', icon: 'bx bxs-truck', ativa: false },
               { nome: 'Ramos de atividade', path: '/pessoas/ramos-atividade', icon: 'bx bx-category', ativa: false }
            ]
         },
         'produtos': {
            nome: 'Produtos',
            icon: 'fal fa-cog',
            tabs: [
               { nome: 'Produtos', path: '/produtos', icon: 'bx bx-package', ativa: true },
               { nome: 'Variações', path: '/produtos/variacoes', icon: 'bx bx-layer', ativa: false },
               { nome: 'Cargas balança', path: '/produtos/cargas-balanca', icon: 'bx bx-download', ativa: false },
               { nome: 'Tabelas de preço', path: '/produtos/tabelas-preco', icon: 'bx bx-table', ativa: false },
               { nome: 'Grupos', path: '/grupos', icon: 'bx bx-category', ativa: false },
               { nome: 'Marcas', path: '/marcas', icon: 'bx bx-purchase-tag', ativa: false },
               { nome: 'Unidades de medida', path: '/unidadesMedida', icon: 'bx bx-ruler', ativa: false },
               { nome: 'Setores', path: '/setores', icon: 'bx bx-buildings', ativa: false },
               { nome: 'Locais de estoque', path: '/produtos/locais-estoque', icon: 'bx bx-map-pin', ativa: false },
               { nome: 'Tributação', path: '/produtos/tributacao', icon: 'bx bx-calculator', ativa: false }
            ]
         },
         'frotas': { nome: 'Frotas', icon: 'far fa-truck', showSingleTab: true, tabs: [{ nome: 'Veículos', path: '/frotas', icon: 'bx bx-trip', ativa: true }] },
         'servicos': {
            nome: 'Serviços',
            icon: 'fal fa-wrench',
            tabs: [
               { nome: 'Serviços', path: '/servicos', icon: 'bx bx-cog', ativa: true },
               { nome: 'Tipos OS', path: '/servicos/tipos-os', icon: 'bx bx-category-alt', ativa: false },
               { nome: 'Equipamentos', path: '/servicos/equipamentos', icon: 'bx bx-devices', ativa: false },
               { nome: 'Modelos de Checklist', path: '/operacional/checklist-modelos', icon: 'bx bx-list-check', ativa: false }
            ]
         },
         'vendas': {
            nome: 'Vendas',
            icon: 'fal fa-cash-register',
            tabs: [
               { nome: 'Vendas', path: '/vendas', icon: 'bx bx-cart', ativa: true }
            ]
         },
         'comercial': {
            nome: 'Comercial',
            icon: 'fal fa-file-invoice',
            tabs: [
               { nome: 'Orçamento', path: '/comercial/orcamento', icon: 'bx bx-receipt', ativa: true },
               { nome: 'Pedido', path: '/comercial/pedido', icon: 'bx bx-cart', ativa: false },
               { nome: 'Devolução de vendas', path: '/comercial/devolucoes', icon: 'bx bx-undo', ativa: false },
               { nome: 'Condicional', path: '/comercial/condicional', icon: 'bx bx-transfer-alt', ativa: false },
               { nome: 'Ordem de serviço', path: '/comercial/ordem-servico', icon: 'bx bx-wrench', ativa: false }
            ]
         },
         'estoque': {
            nome: 'Estoque',
            icon: 'fal fa-boxes',
            tabs: [
               { nome: 'Ajuste de estoque', path: '/estoque/ajuste', icon: 'bx bx-edit', ativa: true },
               { nome: 'Pedido de compra', path: '/estoque/pedidos-compra', icon: 'bx bx-cart', ativa: false },
               { nome: 'Transferência de estoque', path: '/estoque/transferencias', icon: 'bx bx-transfer-alt', ativa: false },
               { nome: 'Controle de gôndola', path: '/estoque/gondola', icon: 'bx bx-barcode-reader', ativa: false },
               { nome: 'Entrada de mercadoria', path: '/estoque/entradas-mercadoria', icon: 'bx bx-package', ativa: false },
               { nome: 'Devolução de compra', path: '/estoque/devolucoes-compra', icon: 'bx bx-undo', ativa: false }
            ]
         },
         'pdv': {
            nome: 'PDV',
            icon: 'fal fa-store',
            tabs: [
               { nome: 'Sessão de caixa', path: '/pdv/caixa', icon: 'bx bx-wallet', ativa: true },
               { nome: 'Supervisor', path: '/pdv/supervisor', icon: 'bx bx-shield-quarter', ativa: false }
            ]
         },
         'pdv-offline': {
            nome: 'PDV Offline',
            icon: 'bx bx-devices',
            tabs: [
               { nome: 'Gerenciamento', path: '/pdvs-offline/gerenciamento', icon: 'bx bx-devices', ativa: true },
               { nome: 'Monitoramento', path: '/pdvs-offline/monitoramento', icon: 'bx bx-desktop', ativa: false },
               { nome: 'Cargas', path: '/pdvs-offline/cargas', icon: 'bx bx-sync', ativa: false },
               { nome: 'Atualizações', path: '/pdvs-offline/atualizacoes', icon: 'bx bx-download', ativa: false },
               { nome: 'Personalização', path: '/pdvs-offline/personalizacao', icon: 'bx bx-palette', ativa: false }
            ]
         },
         'fiscal': {
            nome: 'Mov. Fiscais',
            icon: 'fal fa-file-invoice',
            tabs: [
               { nome: 'Notas Fiscais', path: '/fiscal/venda', icon: 'bx bx-file', ativa: true },
               { nome: 'Notas de Serviço', path: '/fiscal/servico', icon: 'bx bx-wrench', ativa: false },
               { nome: 'Manifestação destinatário', path: '/fiscal/manifestacao-destinatario', icon: 'bx bx-inbox', ativa: false },
               { nome: 'Conhecimento Transporte', path: '/fiscal/cte', icon: 'bx bx-file-blank', ativa: false },
               { nome: 'Manifesto Documentos', path: '/fiscal/mdfe', icon: 'bx bx-trip', ativa: false },
               { nome: 'CIOT', path: '/fiscal/ciot', icon: 'bx bx-id-card', ativa: false }
            ]
         },
         'arquivos-contabeis': {
            nome: 'Arquivos Contábeis',
            icon: 'fal fa-file-export',
            tabs: [
               { nome: 'Exportação XML', path: '/fiscal/arquivos/xml', icon: 'bx bx-export', ativa: true },
               { nome: 'SPED Fiscal', path: '/fiscal/arquivos/sped', icon: 'bx bx-spreadsheet', ativa: false },
               { nome: 'Faturamento', path: '/fiscal/arquivos/faturamento', icon: 'bx bx-receipt', ativa: false }
            ]
         },
         'relatorios': {
            nome: 'Relatórios',
            icon: 'fal fa-chart-line',
            tabs: [
               { nome: 'Comissões', path: '/relatorios/comissoes', icon: 'bx bx-line-chart', ativa: true },
               { nome: 'Fluxo de Caixa', path: '/relatorios/fluxo-caixa', icon: 'bx bx-line-chart', ativa: false },
               { nome: 'Posição de estoque', path: '/relatorios/estoque-posicao', icon: 'bx bx-box', ativa: false },
               { nome: 'Fechamentos PDV', path: '/relatorios/pdv/fechamentos', icon: 'bx bx-history', ativa: false },
               { nome: 'Vendas PDV', path: '/relatorios/pdv/vendas', icon: 'bx bx-chart', ativa: false },
               { nome: 'Ticket Médio', path: '/relatorios/pdv/ticket-medio', icon: 'bx bx-bar-chart-alt-2', ativa: false },
               { nome: 'Relatórios Dinâmicos', path: '/relatorios/dinamico', icon: 'bx bx-customize', ativa: false }
            ]
         },
         'convenios': {
            nome: 'Convênios',
            icon: 'fal fa-wallet',
            tabs: [
               { nome: 'Afiliados', path: '/convenios/afiliados', icon: 'bx bx-id-card', ativa: true },
               { nome: 'Relatórios', path: '/convenios/relatorios', icon: 'bx bx-chart', ativa: false }
            ]
         },
         'financeiro-cadastros': {
            nome: 'Financeiro · Cadastros',
            icon: 'fal fa-dollar-sign',
            tabs: [
               { nome: 'Plano de Contas', path: '/planoContas', icon: 'bx bx-spreadsheet', ativa: true },
               { nome: 'Centro de Custos', path: '/centroCustos', icon: 'bx bx-detail', ativa: false },
               { nome: 'Contas Operacionais', path: '/contasOperacionais', icon: 'bx bx-wallet', ativa: false },
               { nome: 'Administradoras de Cartão', path: '/administradorasCartao', icon: 'bx bx-credit-card-front', ativa: false },
               { nome: 'Formas de Pagamento', path: '/formasPagamento', icon: 'bx bx-credit-card', ativa: false },
               { nome: 'Condições de Pagamento', path: '/condicoesPagamento', icon: 'bx bx-calendar-check', ativa: false }
            ]
         },
         'financeiro-operacional': {
            nome: 'Financeiro · Operacional',
            icon: 'fal fa-wallet',
            tabs: [
               { nome: 'Contas a Pagar', path: '/contasAPagar', icon: 'bx bx-transfer-alt', ativa: true },
               { nome: 'Contas a Receber', path: '/contasAReceber', icon: 'bx bx-money', ativa: false },
               { nome: 'Borderô de Cartões', path: '/financeiro/borderos-cartao', icon: 'bx bx-credit-card-front', ativa: false },
               { nome: 'Saldo de contas', path: '/financeiro/saldo-contas', icon: 'bx bx-wallet', ativa: false },
               { nome: 'Fechamentos de Caixa', path: '/financeiro/fechamentos-caixa', icon: 'bx bx-spreadsheet', ativa: false }
            ]
         },
         'financeiro-configuracoes': {
            nome: 'Configurações',
            icon: 'fal fa-cog',
            tabs: [
               { nome: 'Dados Fiscais Empresa', path: '/configuracoes/fiscal', icon: 'bx bx-receipt', ativa: true },
               { nome: 'Operações', path: '/configuracoes/operacoes', icon: 'bx bx-list-ul', ativa: false },
               { nome: 'PDV', path: '/configuracoes/pdv', icon: 'bx bx-store', ativa: false },
               { nome: 'Comercial', path: '/configuracoes/comercial', icon: 'bx bx-cart', ativa: false },
               { nome: 'Produtos/Serviços', path: '/configuracoes/produtos-servicos', icon: 'bx bx-package', ativa: false },
               { nome: 'Pessoas', path: '/configuracoes/pessoas', icon: 'bx bx-id-card', ativa: false },
               { nome: 'Financeiro', path: '/configuracoes/financeiro', icon: 'bx bx-wallet', ativa: false },
               { nome: 'Estoque', path: '/configuracoes/estoque', icon: 'bx bx-box', ativa: false },
               { nome: 'Comunicação / WhatsApp', path: '/configuracoes/whatsapp', icon: 'bxl-whatsapp', ativa: false }
            ]
         },
         'changelog': {
            nome: 'Changelog',
            icon: 'bx bx-history',
            tabs: [
               { nome: 'Changelog', path: '/changelog', icon: 'bx bx-history', ativa: true, role: null }
            ]
         },
         'assinatura': {
            nome: 'Minha Assinatura',
            icon: 'bx bx-badge-check',
            tabs: [
               { nome: 'Minha Assinatura', path: '/assinatura', icon: 'bx bx-badge-check', ativa: true, role: null }
            ]
         },
         'support': {
            nome: 'Suporte / Report',
            icon: 'bx bx-support',
            tabs: [
               { nome: 'Meus Tickets', path: '/sistema/suporte/tickets', icon: 'bx bx-list-ul', ativa: true, role: null },
               { nome: 'Reportar', path: '/sistema/reportar-suporte', icon: 'bx bx-support', ativa: false, role: null }
            ]
         }
      },
      secaoAtiva: 'pagina-inicial'
   },
   mutations: {
      setTotalUnreadChatMessages: (state, total) => {
         state.totalUnreadChatMessages = total;
      },
      imageError: (state, e) => {
         e.target.src = imgError
      },
      addTabData: (state, route) => {
         let index = state.tabs.findIndex(tab => tab.id == route.id)

         if (index == -1) {
            state.tabs.push(route)
         }
      },
      attTabData: (state, route) => {
         let index = state.tabs.findIndex(tab => tab.id == route.id)

         if (index != -1) {
            state.tabs[index].data = route.data
            Vue.prototype.$set(state.tabs, index, state.tabs[index])
         }
      },
      deleteTabData: (state, index) => {
         state.tabs.splice(index, 1)

         if (state.tabs.length > 0) {
            state.tabs.forEach((tab, index) => {
               tab.id = index
               tab.path = tab.path.substring(0, tab.path.lastIndexOf("/") + 1) + index
            });

            let lastTab = state.tabs[state.tabs.length - 1]
            /* eslint-disable-next-line no-useless-escape */
            router.push(lastTab.path + "?" + JSON.stringify(lastTab.query).replace(/[\{\}]|["]/g, "").replace(/[:]/g, "=").replace(/[,]/g, "&")).catch()
         }
      },
      deleteTabs: state => {
         router.push('/paginaInicial/0')
         state.tabs.splice(1, state.tabs.length)
      },
      verificarCredenciais: (state, credenciais) => {
         // Se credenciais não foram passadas, verificar se há credenciais salvas no localStorage
         if (!credenciais && (localStorage.email || localStorage.cpf) && localStorage.password) {
            credenciais = {
               "email": localStorage.email ? localStorage.email.split(/(\w\w)/g).filter(p => !!p).map(c => String.fromCharCode(parseInt(c, 16))).join("") : null,
               "cpf": localStorage.cpf ? localStorage.cpf.split(/(\w\w)/g).filter(p => !!p).map(c => String.fromCharCode(parseInt(c, 16))).join("") : null,
               "password": localStorage.password.split(/(\w\w)/g).filter(p => !!p).map(c => String.fromCharCode(parseInt(c, 16))).join(""),
               "manterConectado": true // Se está vindo do localStorage, significa que estava marcado
            };
         }
         if (!credenciais) {
            return
         }
         if ((credenciais.cpf == null || credenciais.cpf.trim().length == 0) && (credenciais.email == null || credenciais.email.trim().length == 0)) {
            Vue.prototype.$toast.fire({
               icon: 'error',
               title: 'CPF ou Email inválido!'
            })
            return
         }
         if (credenciais.password == null || credenciais.password.trim().length == 0) {
            Vue.prototype.$toast.fire({
               icon: 'error',
               title: 'Senha inválida!'
            })
            return
         }

         state.loadingCount++

         Vue.prototype.$axios({
            method: 'post',
            url: state.urlRest + 'auth/login',
            headers: { 'Content-Type': 'application/json' },
            data: {
               "cpf": credenciais.cpf || null,
               "email": credenciais.email || null,
               "password": credenciais.password
            }
         }).then(function (response) {
            state.dadosUsuario = response.data
            // Salvar permissões globais para cruzamento com planos depois
            state.dadosUsuario.globalRoles = [...(response.data.roles || [])]
            state.dadosUsuario.globalModules = [...(response.data.modules || [])]
            state.isLogado = true

            // Pega o token do header (X-Auth-Token) OU do corpo
            let token = response.headers && response.headers['x-auth-token']
            if (!token && response.headers && response.headers.get) {
               token = response.headers.get('X-Auth-Token');
            }
            if (!token && response.data.tokenSessao) {
               token = response.data.tokenSessao
            }
            state.tokenSessao = token

            if (token) {
               Vue.prototype.$axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            }

            if (credenciais.manterConectado) {
               // Salvar email se existir
               if (credenciais.email) {
                  localStorage.email = credenciais.email.split("").map(c => c.charCodeAt(0).toString(16).padStart(2, "0")).join("")
               }
               // Salvar cpf se existir
               if (credenciais.cpf) {
                  localStorage.cpf = credenciais.cpf.split("").map(c => c.charCodeAt(0).toString(16).padStart(2, "0")).join("")
               }
               // Sempre salvar a senha
               localStorage.password = credenciais.password.split("").map(c => c.charCodeAt(0).toString(16).padStart(2, "0")).join("")
            }

            // Tentar restaurar empresa salva do localStorage se ainda estiver na lista de empresas do usuário
            const empresaSalva = localStorage.getItem('empresaSelecionada')
            if (empresaSalva && response.data && response.data.companies && Array.isArray(response.data.companies)) {
               try {
                  const empresa = JSON.parse(empresaSalva)
                  // Verificar se a empresa salva ainda está na lista de empresas do usuário e está ativa
                  const empresaEncontrada = response.data.companies.find(emp => emp.id === empresa.id && emp.status === 'ACTIVE')
                  if (empresaEncontrada) {
                     // Restaurar empresa salva
                     state.empresa = empresaEncontrada

                     // Ajustar permissões baseadas no plano da empresa
                     if (state.dadosUsuario && state.dadosUsuario.globalRoles) {
                        if (empresaEncontrada.planRoles && empresaEncontrada.planRoles.length > 0) {
                           state.dadosUsuario.roles = state.dadosUsuario.globalRoles.filter(r => empresaEncontrada.planRoles.includes(r))
                        } else {
                           state.dadosUsuario.roles = [...state.dadosUsuario.globalRoles]
                        }

                        if (empresaEncontrada.planModules && empresaEncontrada.planModules.length > 0) {
                           state.dadosUsuario.modules = state.dadosUsuario.globalModules.filter(m => empresaEncontrada.planModules.includes(m))
                        } else {
                           state.dadosUsuario.modules = [...state.dadosUsuario.globalModules]
                        }

                        // Mapear permissoes do PDV e turnos
                        if (state.dadosUsuario.companyAccesses) {
                           const access = state.dadosUsuario.companyAccesses.find(a => a.companyId === empresaEncontrada.id);
                           if (access) {
                              state.dadosUsuario.pdvPermissions = access.pdvPermissions || [];
                              state.dadosUsuario.turnoIds = access.turnoIds || [];
                              state.dadosUsuario.senhaBarra = access.senhaBarra || null;
                              state.dadosUsuario.fechamentoCaixaAsCegas = access.fechamentoCaixaAsCegas || false;
                           }
                        }
                     }

                     // Salvar também em dadosEmpresa quando empresa é restaurada
                     state.dadosEmpresa = empresaEncontrada
                     localStorage.setItem('empresaSelecionada', JSON.stringify(empresaEncontrada))
                     Vue.prototype.$axios.defaults.headers.common['X-Company-Id'] = empresaEncontrada.id;

                     // No recarregamento, restaurar a rotina e os filtros da mesma aba do navegador.
                     const rotaSalva = getLastAppRoute()
                     const destino = rotaSalva && router.resolve(rotaSalva).route.matched.length ? rotaSalva : '/paginaInicial'
                     if (router.currentRoute.fullPath !== destino) {
                        router.replace(destino).catch(() => {
                           if (router.currentRoute.path !== '/paginaInicial') router.replace('/paginaInicial').catch(() => { })
                        })
                     }
                     return // Não precisa ir para seleção de empresa
                  }
               } catch (e) {
                  // Se houver erro ao parsear, limpar localStorage
                  localStorage.removeItem('empresaSelecionada')
               }
            }

            // Se não restaurou empresa, limpar empresa do state e redirecionar para seleção
            state.empresa = null
            state.dadosEmpresa = null

            // Após login bem-sucedido, redirecionar para seleção de empresas
            if (router.currentRoute.path !== '/selecaoEmpresa') {
               router.push('/selecaoEmpresa').catch(() => { })
            }
         }).catch(function (error) {
            store.mutations.deslogar(state)
            if (error.response != undefined) {
               if (error.response.status == 401 || error.response.status == 404) {
                  Vue.prototype.$toast.fire({
                     icon: 'error',
                     title: 'Credenciais incorretas!'
                  });
               } else {
                  Vue.prototype.$toast.fire({
                     icon: 'error',
                     title: 'Erro: ' + (error.response.data || error.response.status)
                  });
               }
            }
         }).finally(() => {
            state.loadingCount--
         });
      },
      deslogar: state => {
         Vue.prototype.$axios({
            method: 'post',
            url: state.urlRest + 'auth/logout',
            headers: { 'Content-Type': 'application/json' }

         }).catch(() => {
            // Se o backend estiver indisponivel, o estado local ainda precisa ser limpo sem gerar erro solto no runtime.
         }).finally(() => {
            state.dadosUsuario = null
            state.isLogado = false
            state.dadosEmpresa = null
            state.empresa = null
            state.tabs = []
            state.secaoAtiva = 'pagina-inicial'
            // Após logout, não precisa redirecionar pois o App.vue vai mostrar o Login automaticamente

            localStorage.removeItem('email')
            localStorage.removeItem('cpf')
            localStorage.removeItem('password')
            localStorage.removeItem('tokenSessao')
            localStorage.removeItem('empresaSelecionada')
            clearLastAppRoute()
            // Limpa Authorization global
            if (Vue.prototype.$axios && Vue.prototype.$axios.defaults && Vue.prototype.$axios.defaults.headers.common['Authorization']) {
               delete Vue.prototype.$axios.defaults.headers.common['Authorization']
            }
         });
      },
      trocarEmpresa: state => {
         state.empresa = null
         localStorage.removeItem('empresaSelecionada')
      },
      alternarTelaCarregamento: (state, valor) => {
         state.loadingCount = state.loadingCount + valor;
      },
      alterarAvatar: (state, avatar) => {
         state.dadosUsuario.avatar = avatar;
      },
      setFontSizeDataLabels: (state, value) => {
         // Garantir que o valor esteja entre 10 e 30
         if (value >= 10 && value <= 30) {
            state.fontSizeDataLabels = value;
            // Salvar no localStorage
            localStorage.setItem('fontSizeDataLabels', value.toString());
         }
      },
      setSecaoAtiva: (state, secao) => {
         state.secaoAtiva = secao;
         // Resetar todas as tabs da seção para inativa
         Object.keys(state.secoes).forEach(key => {
            state.secoes[key].tabs.forEach(tab => {
               tab.ativa = false;
            });
         });
         // Ativar a primeira tab da seção
         if (state.secoes[secao] && state.secoes[secao].tabs.length > 0) {
            state.secoes[secao].tabs[0].ativa = true;
         }
      },
      ativarTab: (state, { secao, tabIndex }) => {
         // Desativar todas as tabs da seção
         state.secoes[secao].tabs.forEach(tab => {
            tab.ativa = false;
         });
         // Ativar a tab selecionada
         if (state.secoes[secao].tabs[tabIndex]) {
            state.secoes[secao].tabs[tabIndex].ativa = true;
         }
      },
      setDadosEmpresa: (state, empresa) => {
         state.dadosEmpresa = empresa;
      },
      setEmpresa: (state, empresa) => {
         state.empresa = empresa;

         // Ajustar permissões baseadas no plano da empresa
         if (state.dadosUsuario && state.dadosUsuario.globalRoles) {
            if (empresa && empresa.planRoles && empresa.planRoles.length > 0) {
               state.dadosUsuario.roles = state.dadosUsuario.globalRoles.filter(r => empresa.planRoles.includes(r))
            } else if (empresa) {
               state.dadosUsuario.roles = [...state.dadosUsuario.globalRoles]
            }

            if (empresa && empresa.planModules && empresa.planModules.length > 0) {
               state.dadosUsuario.modules = state.dadosUsuario.globalModules.filter(m => empresa.planModules.includes(m))
            } else if (empresa) {
               state.dadosUsuario.modules = [...state.dadosUsuario.globalModules]
            } else {
               // Se não há empresa selecionada (ex: saindo), restaura as globais (opcional)
               state.dadosUsuario.roles = [...state.dadosUsuario.globalRoles]
               state.dadosUsuario.modules = [...state.dadosUsuario.globalModules]
            }

            // Mapear permissoes do PDV e turnos
            if (empresa && state.dadosUsuario.companyAccesses) {
               const access = state.dadosUsuario.companyAccesses.find(a => a.companyId === empresa.id);
               if (access) {
                  state.dadosUsuario.pdvPermissions = access.pdvPermissions || [];
                  state.dadosUsuario.turnoIds = access.turnoIds || [];
                  state.dadosUsuario.senhaBarra = access.senhaBarra || null;
                  state.dadosUsuario.fechamentoCaixaAsCegas = access.fechamentoCaixaAsCegas || false;
               } else {
                  state.dadosUsuario.pdvPermissions = [];
                  state.dadosUsuario.turnoIds = [];
                  state.dadosUsuario.senhaBarra = null;
                  state.dadosUsuario.fechamentoCaixaAsCegas = false;
               }
            } else {
               state.dadosUsuario.pdvPermissions = [];
               state.dadosUsuario.turnoIds = [];
               state.dadosUsuario.senhaBarra = null;
               state.dadosUsuario.fechamentoCaixaAsCegas = false;
            }
         }

         // Salvar também em dadosEmpresa quando uma empresa é selecionada
         state.dadosEmpresa = empresa;
         // Salvar empresa no localStorage
         if (empresa) {
            localStorage.setItem('empresaSelecionada', JSON.stringify(empresa));
            Vue.prototype.$axios.defaults.headers.common['X-Company-Id'] = empresa.id;
         } else {
            localStorage.removeItem('empresaSelecionada');
            delete Vue.prototype.$axios.defaults.headers.common['X-Company-Id'];
         }
      },
      updateProductFieldConfig: (state, productFieldConfig) => {
         if (state.dadosEmpresa) {
            // Atualizar productFieldConfig no dadosEmpresa
            state.dadosEmpresa.productFieldConfig = productFieldConfig;
            // Também atualizar no empresa para manter sincronizado
            if (state.empresa) {
               state.empresa.productFieldConfig = productFieldConfig;
            }
            // Atualizar no localStorage
            localStorage.setItem('empresaSelecionada', JSON.stringify(state.dadosEmpresa));
         }
      }
   },
   actions: {
      updateUnreadChatMessages: ({ commit, state }) => {
         if (state.isLogado) {
            Vue.prototype.$axios.get(state.urlRest + 'chat/conversas/unread-count')
               .then(res => commit('setTotalUnreadChatMessages', res.data.total))
               .catch(() => { });
         }
      },
      imageError: ({ commit }, e) => {
         commit('imageError', e)
      },
      addTabData: ({ commit }, route) => {
         commit('addTabData', route)
      },
      attTabData: ({ commit }, route) => {
         commit('attTabData', route)
      },
      deleteTabData: ({ commit }, index) => {
         commit('deleteTabData', index)
      },
      toggleTelaAjuda: ({ commit }, tela) => {
         commit('toggleTelaAjuda', tela)
      },
      verificarCredenciais: ({ commit }, credenciais) => {
         commit('verificarCredenciais', credenciais)
      },
      verificarAutoLogin: ({ commit }) => {
         // Verificar se há credenciais salvas no localStorage
         if ((localStorage.email || localStorage.cpf) && localStorage.password) {
            commit('verificarCredenciais', null) // Passar null para usar credenciais do localStorage
         }
      },
      alternarTelaCarregamento: ({ commit }, valor) => {
         commit('alternarTelaCarregamento', valor)
      },
      alterarAvatar: ({ commit }, avatar) => {
         commit('alterarAvatar', avatar)
      },
      deleteTabs: context => context.commit('deleteTabs'),
      deslogar: context => context.commit('deslogar'),
      trocarEmpresa: context => context.commit('trocarEmpresa'),
      setSecaoAtiva: ({ commit }, secao) => {
         commit('setSecaoAtiva', secao)
      },
      ativarTab: ({ commit }, { secao, tabIndex }) => {
         commit('ativarTab', { secao, tabIndex })
      },
      setDadosEmpresa: ({ commit }, empresa) => {
         commit('setDadosEmpresa', empresa)
      },
      setEmpresa: ({ commit }, empresa) => {
         commit('setEmpresa', empresa)
      },
      updateProductFieldConfig: ({ commit }, productFieldConfig) => {
         commit('updateProductFieldConfig', productFieldConfig)
      },
      buscarCEP: ({ state, commit }, cep) => {
         return new Promise((resolve, reject) => {
            consultarCep(cep).then(data => {
               resolve(data)
            }).catch(function (error) {
               Vue.prototype.$toast.fire({
                  icon: 'error',
                  title: 'Erro: ' + error.message,
               });
               reject(null)
            });
         })
      },
      // Quem chama controla o carregamento (alternarTelaCarregamento +1/-1); decrementar aqui deixava o contador negativo
      buscarCNPJ: ({ state, commit }, cnpj) => {
         return new Promise((resolve, reject) => {
            Vue.prototype.$axios({
               method: 'get',
               url: state.urlRest + `consultas/cnpj/${cnpj}`
            }).then(response => {
               if (response.data == null) {
                  reject(null)
               } else {
                  resolve(response.data)
               }
            }).catch((error) => {
               if (error.response != undefined) {
                  const msg = error.response.data?.message || 'Erro: CNPJ inválido ou não encontrado';
                  Vue.prototype.$toast.fire({
                     icon: 'error',
                     title: msg,
                  });
               }
               reject(null)
            });
         });
      },
      formatValue: ({ commit }, data) => {
         return new Promise((resolve, reject) => {
            let value = String(data.valor).replace(/[^\d-]/g, '');

            while (value.length <= data.digitos) {
               value = '0' + value;
            }

            if (data.digitos === 0) {
               resolve(parseInt(value));
            } else {
               resolve(parseInt(value.slice(0, -data.digitos)) + '.' + value.slice(-data.digitos))
            }
         })
      },
      base64toFile: ({ commit }, base64Data) => {
         return new Promise((resolve, reject) => {
            if (base64Data.length == 0) {
               resolve([])
            }

            for (let i = 0; i < base64Data.length; i++) {
               if (String(base64Data[i]).startsWith('data:')) {
                  let byteCharacters = atob(base64Data[i].split(';base64,').pop());
                  let byteNumbers = new Array(byteCharacters.length);

                  for (let i = 0; i < byteCharacters.length; i++) {
                     byteNumbers[i] = byteCharacters.charCodeAt(i);
                  }

                  let blob = new Blob([new Uint8Array(byteNumbers)], { type: 'image/png' });
                  base64Data[i] = new File([blob], 'imagem.png', { type: blob.type });
               }

               if (i == (base64Data.length - 1)) {
                  resolve(base64Data)
               }
            }
         })
      },

   },
   modules: {
   }
}

export default new Vuex.Store(store);
